<template>
  <div class="header">
    <div class="logo">
      <img class="logo-img" src="../../assets/dwd-logo.png" alt="多维度" />
      <h3 class="logo-text" v-text="commonParams.sys.logoText"></h3>
      <span class="logo-mini" v-if="commonParams.sys.logoMiniCls">
        <div :class="['logo-mini-pic', commonParams.sys.logoMiniCls]"></div>
      </span>
    </div>
  </div>
</template>
<script>
import { commonParams } from '@/libs/commonParamsStore.js'
export default {
  name: 'PcHeader',
  data() {
    return {
      commonParams,
    }
  },
}
</script>
<style lang="less" scoped>
.header {
  min-width: 800px;
  background: #fff;
  height: 84px;
}
.logo {
  padding-left: 156px;
  float: left;
  height: 38px;
  width: fit-content;
  margin-top: 30px;
  position: relative;
  img {
    display: inline-block;
    height: 29px;
    width: 89px;
    bottom: 0px;
    position: relative;
  }
  h3 {
    display: inline-block;
    height: 20px;
    font-family: PingFangSC-Medium;
    font-size: 20px;
    line-height: 20px;
    color: #333333;
    margin-left: 15px;
    bottom: 2px;
    position: relative;
  }
}
.logo-mini {
  display: inline-block;
  height: inherit;
  bottom: 0px;
  position: relative;
  width: 74px;
  .logo-mini-pic {
    width: 38px;
    height: 38px;
    display: inline-block;
    background-size: contain;
    position: absolute;
    bottom: -2px;
    margin-left: 35px;

    background-repeat: no-repeat;
    background-position: left bottom;
    &.logo-mini-hsq {
      background-image: url(../../assets/logo-haoshiqi.png);
    }
    &.logo-mini-jsz {
      background-image: url(../../assets/logo-jsz.png);
    }
  }
}
.logo-mini:before {
  content: ' ';
  background-color: #cccccc;
  height: 24px;
  width: 1px;
  position: absolute;
  bottom: 3px;
  left: 15px;
  border-radius: 2px;
}
</style>
